<template>
  <div class="page">
    <div class="user-card">
      <div class="box-card" shadow="never">
        <div slot="header" class="clearfix">
          <span class="title">个人信息</span>
        </div>
        <div class="user-avatar">
          <img src="../../assets/logo.png" width="100%" height="auto" />
        </div>
        <div class="user-info">
          <div class="user-info-item">
            <div class="item-left">昵称</div>
            <div class="item-right">
              <div class="right-text">{{ userInfo.nickname }}</div>
              <div class="right-icon">
                <el-tooltip content="《你的名字》" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="user-info-item">
            <div class="item-left">用户名</div>
            <div class="item-right">
              <div class="right-text">{{ userInfo.username }}</div>
              <div class="right-icon">
                <el-tooltip content="《你的名字》" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="user-info-item">
            <div class="item-left">角色</div>
            <div class="item-right">
              <div class="right-text">
                {{
                  userInfo.role
                    ? userInfo.role.name
                    : userInfo.role_id == 1
                    ? "Admin"
                    : "正在查询...."
                }}
              </div>
              <div class="right-icon">
                <el-tooltip content="角色代表着你的权力" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="user-info-item">
            <div class="item-left">手机号</div>
            <div class="item-right">
              <div class="right-text">{{ userInfo.mobile }}</div>
              <div class="right-icon">
                <el-tooltip content="正如所看到的就是手机号" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="user-info-item">
            <div class="item-left">认证情况</div>
            <div class="item-right">
              <div class="right-text">
                <el-tag :type="userInfo.bind_official ? 'success' : 'danger'">{{
                  userInfo.bind_official ? "已认证" : "未认证"
                }}</el-tag>
              </div>
              <div class="right-icon">
                <div v-if="userInfo.bind_official">
                  <el-tooltip content="已绑定微信" placement="top">
                    <el-button type="text">已绑定</el-button>
                  </el-tooltip>
                </div>
                <div v-else>
                  <el-tooltip
                    content="扫描二维码绑关注公众号来定微信"
                    placement="top"
                  >
                    <el-button type="text" @click="getWechatRcode"
                      >绑定微信</el-button
                    >
                    <!-- <i class="el-icon-question"></i> -->
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        title="扫描下方二维码"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <span>
          <img :src="wechatRcode" width="100%" height="auto" alt="" />
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as user from "@/api/user.js";
export default {
  data() {
    return {
      dialogVisible: false,
      userInfo: {},
      wechatRcode: ""
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      user.getUserInfo().then(res => {
        this.userInfo = res.user;
      });
    },
    getWechatRcode() {
      user.getWechatRcode.r().then(res => {
        this.wechatRcode = "data:image/png;base64," + res.img;
        this.dialogVisible = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;

  // justify-content: center;
  .user-card {
    margin-top: 20px;
    width: 100%;
    min-width: 40%;
    .box-card {
      width: 100%;

      .clearfix {
        .title {
          font-size: 18px;
          border-left: 4px solid #3296fa;
          padding-left: 20px;
        }
      }
      .user-avatar {
        width: 30%;
        margin: 50px auto;
      }
      .user-info {
        padding: 0 20px;
        .user-info-item {
          font-size: 16px;
          display: flex;
          // padding: 20px 0;
          line-height: 70px;
          // justify-content: space-between;
          .item-left {
            color: #999;
            width: 100px;
          }
          .item-right {
            border-bottom: 1px solid #e4e7ed;
            width: calc(100% - 100px);
            display: flex;
            justify-content: space-between;
            .right-text {
              color: #606266;
            }
            .right-icon {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
